import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';

import ArrowsAiPageRouteView from './pages/ArrowsAiPageRouteView.vue';
import AssistantsIndex from './assistants/Index.vue';
import AssistantOverview from './assistants/overview/Index.vue';
import AssistantInstructions from './assistants/instructions/Index.vue';
import AssistantFaqs from './assistants/faqs/Index.vue';
import AssistantDocuments from './assistants/documents/Index.vue';
import AssistantResources from './assistants/resources/Index.vue';
import AssistantServices from './assistants/services/Index.vue';
import AssistantTools from './assistants/tools/Index.vue';
import AssistantPlayground from './assistants/playground/Index.vue';
import AssistantInboxes from './assistants/inboxes/Index.vue';
import AssistantSettings from './assistants/settings/Index.vue';
import AssistantSystemSettings from './assistants/settings/System.vue';
import AssistantScheduleSettings from './assistants/settings/Schedule.vue';
import AssistantLimitsSettings from './assistants/settings/Limits.vue';
import AssistantReplyStyleSettings from './assistants/settings/ReplyStyle.vue';

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.ARROWS_AI,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/arrows-ai'),
    component: ArrowsAiPageRouteView,
    meta,
    children: [
      {
        path: '',
        redirect: to => ({
          name: 'arrows_ai_assistants_index',
          params: to.params,
        }),
      },
      {
        path: 'assistants',
        name: 'arrows_ai_assistants_index',
        component: AssistantsIndex,
        meta,
      },
      {
        path: ':assistantId/overview',
        name: 'arrows_ai_assistants_overview',
        component: AssistantOverview,
        meta,
      },
      {
        path: ':assistantId/instructions',
        name: 'arrows_ai_assistants_instructions',
        component: AssistantInstructions,
        meta,
      },
      {
        path: ':assistantId/faqs',
        name: 'arrows_ai_assistants_faqs',
        component: AssistantFaqs,
        meta,
      },
      {
        path: ':assistantId/documents',
        name: 'arrows_ai_assistants_documents',
        component: AssistantDocuments,
        meta,
      },
      {
        path: ':assistantId/resources',
        name: 'arrows_ai_assistants_resources',
        component: AssistantResources,
        meta,
      },
      {
        path: ':assistantId/services',
        name: 'arrows_ai_assistants_services',
        component: AssistantServices,
        meta,
      },
      {
        path: ':assistantId/tools',
        name: 'arrows_ai_assistants_tools',
        component: AssistantTools,
        meta,
      },
      {
        path: ':assistantId/playground',
        name: 'arrows_ai_assistants_playground',
        component: AssistantPlayground,
        meta,
      },
      {
        path: ':assistantId/inboxes',
        name: 'arrows_ai_assistants_inboxes',
        component: AssistantInboxes,
        meta,
      },
      {
        path: ':assistantId/settings',
        name: 'arrows_ai_assistants_settings',
        component: AssistantSettings,
        meta,
      },
      {
        path: ':assistantId/settings/system',
        name: 'arrows_ai_assistants_settings_system',
        component: AssistantSystemSettings,
        meta,
      },
      {
        path: ':assistantId/settings/schedule',
        name: 'arrows_ai_assistants_settings_schedule',
        component: AssistantScheduleSettings,
        meta,
      },
      {
        path: ':assistantId/settings/limits',
        name: 'arrows_ai_assistants_settings_limits',
        component: AssistantLimitsSettings,
        meta,
      },
      {
        path: ':assistantId/settings/reply-style',
        name: 'arrows_ai_assistants_settings_reply_style',
        component: AssistantReplyStyleSettings,
        meta,
      },
    ],
  },
];
